import { connect } from "react-redux"
import Input from "../../components/search-input"

const mapStateToProps = state => ({
  value: state.currentShop.productFilter.value
})

const mapDispatchToProps = dispatch => ({
  onChange: (value) => dispatch({type: "SHOP.CHANGE_PRODUCT_FILTER", payload: {value}})
})

export default connect(mapStateToProps, mapDispatchToProps)(Input)
